/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */

const g = globalThis as any;
const query = new URLSearchParams(window.location.search);

// g.__host = {
//     baseUrl: 'https://test.ludi.co',
//     env: 'dev',
// };

const localhost = window.location.hostname.match(/localhost|ngrok/);
const kiosk = !g.__host;

const env = g.__host?.env;
const siteId = g.__host?.siteId ?? null;
const baseUrl = g.__host?.baseUrl ?? '';
const apiUrl = `${baseUrl}/api/v2`;
const collabUrl = (localhost ? 'http://localhost:8888/ps' : `${baseUrl}/ps`).replace(/^http/, 'ws');
const offline = kiosk || (query.get('offline') === '1' || query.get('offline') === 'true');

const selfScript = Array.from(document.querySelectorAll('script'))
    .find(x => x.src.match(/\/app\/index\.js/));
const cdnUrl = selfScript?.src?.replace(/\/app\/index\.js/, '');
const absUrl = (path: string) => {
    path = path.replace(/\/\//g, '/');
    if (path.startsWith('~/')) path = path.slice(1);
    while (path.startsWith('/')) path = path.slice(1);
    return `${baseUrl}/${path}`;
};

export const Host = { env, baseUrl, apiUrl, cdnUrl, collabUrl, siteId, offline, absUrl, kiosk };
